<template>
    <div>
        <h1 style="font-size: 24px; color: black;">渠道管理</h1>
        <el-button type="primary" @click="showAddChannelDialog(0, '新增渠道')">添加渠道</el-button>
        <h1>
            <el-table
                :data="channelList.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"
                style="width: 100%;margin-bottom: 20px;" row-key="name"
                border
                @sort-change='sortChange'
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column prop="name" label="渠道名" align="center"></el-table-column>
                <el-table-column prop="subChannel" label="子渠道号" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.subChannel === undefined ? scope.row.id : scope.row.subChannel }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="更新时间" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.subChannel != null ">{{ formatDate(scope.row.dtUpdate) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="开关" sortable="custom" align="center">
                    <template slot-scope="scope">
                        <el-switch v-if="scope.row.subChannel != null "
                                   v-model="scope.row.state"
                                   :width="58"
                                   :active-value="1"
                                   :inactive-value="0"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="gameName" label="首开展示" align="center"></el-table-column>
                <el-table-column prop="adPlateName" label="旧版聚合平台" align="center"></el-table-column>
                <el-table-column prop="adPlateNewName" label="新版聚合平台" align="center"></el-table-column>
                <el-table-column prop="minVersion" label="最小版本号" align="center"></el-table-column>
                <el-table-column prop="maxVersion" label="最大版本号" align="center"></el-table-column>
                <el-table-column prop="money" label="会员价格" align="center"></el-table-column>
                <el-table-column prop="appName" label="应用" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="showAddChannelDialog(1, '编辑渠道', scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addChannelDialogVisible" center
                       @close="closeAddChannelDialog" :close-on-click-modal="false">
                <el-form :model="addChannelForm" ref="cateForm">
                    <el-form-item label="选择渠道类型">
                        <el-radio v-model="radio" label='0' :disabled="dialogType===1">渠道组</el-radio>
                        <el-radio v-model="radio" label='1' :disabled="dialogType===1">子渠道</el-radio>
                    </el-form-item>
                    <el-form-item label="选择渠道组" v-if="radio ==='1' ">
                        <el-select v-model="addChannelForm.channelId">
                            <el-option v-for="channel in channelList" :key="channel.id" :value="channel.id"
                                       :label="channel.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="渠道名称">
                        <div v-if="radio==='0'">
                            <el-input v-model.trim="addChannelForm.name" clearable></el-input>
                        </div>
                        <div v-if="radio==='1'">
                            <el-input v-model.trim="addChannelForm.subName" clearable></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="子渠道号" v-if="radio ==='1' ">
                        <el-input v-model.trim="addChannelForm.subChannel" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="老广告聚合平台" v-if="radio ==='1' ">
                        <el-select v-model="addChannelForm.adPlate">
                            <el-option v-for="adPlate in adPlateEnum" :key="adPlate.id" :value="adPlate.id"
                                       :label="adPlate.name">
                            </el-option>
                        </el-select>
                        <span style="color: red">谨慎修改，会影响线上</span>
                    </el-form-item>
                    <el-form-item label="新广告聚合平台" v-if="radio ==='1' ">
                        <el-select v-model="addChannelForm.adPlateNew">
                            <el-option v-for="adPlate in adPlateEnum" :key="adPlate.id" :value="adPlate.id"
                                       :label="adPlate.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员价格" v-if="radio ==='1' ">
                        <el-input v-model="addChannelForm.money"></el-input>
                    </el-form-item>
                    <el-form-item label="最小兼容版本号(>=):" v-if="radio ==='1' ">
                        <el-input-number v-model="addChannelForm.minVersion" :min="65"></el-input-number>
                    </el-form-item>
                    <el-form-item label="最大兼容版本号(<=):" v-if="radio ==='1' ">
                        <el-input-number v-model="addChannelForm.maxVersion" :min="65"></el-input-number>
                    </el-form-item>
                    <el-form-item label="首开展示" v-if="radio ==='1' ">
                        <el-select v-model="addChannelForm.gameId" filterable>
                            <el-option v-for="game in gameList" :key="game.id" :value="game.id" :label="game.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="应用" v-if="radio ==='1' ">
                        <el-select v-model="addChannelForm.appId">
                            <el-option v-for="app in appList" :key="app.appId" :value="app.appId"
                                       :label="app.appName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                   <el-button type="primary" @click="confirmAddChannelDialog">确 定</el-button>
                   <el-button type="info" @click="closeAddChannelDialog">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-row>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum"
                :page-sizes="[10,20,50,100]"
                :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next"
                :total="channelList.length">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
import {adPlateEnum, appAll, channelEdit, channelList, gameSimpleList, updateState} from "@/http/api"
import utils from '@/utils'

export default {
    inject: ['reload'],
    name: "ChannelList",
    data() {
        return {
            radio: '0',
            dialogTitle: '',
            dialogType: 0,
            isFold: false,
            addChannelDialogVisible: false,
            addChannelForm: {
                channelId: '',
                subChannelId: 0,
                gameId: '',
                name: '',
                state: 0,
                subName: '',
                subChannel: '',
                adPlate: '',
                adPlateNew: '',
                minVersion: 65,
                maxVersion: 65,
                money:0
            },
            channelList: [],
            gameList: [],
            appList: [],
            adPlateEnum: [],
            queryInfo: {
                pagesize: 100,
                pagenum: 1,
            },
        }
    },

    methods: {
        formatDate: function (column) {
            return utils.DateUtil.formatDate(column, "YYYY-MM-DD HH:mm:ss")
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;

        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;

        },
        sortChange(order) {
            if (order.order === "descending") {
                this.openDesc()
            } else if (order.order === "ascending") {
                this.openAsc()
            }
        },
        showAddChannelDialog(_type, _title, _data) {
            this.selectList();
            this.dialogType = _type;
            this.dialogTitle = _title;
            this.addChannelForm = {
                channelId: '',
                subChannelId: 0,
                gameId: '',
                appId: '',
                name: '',
                subName: '',
                subChannel: '',
                adPlate: '',
                adPlateNew: '',
                money:0,
                state: 0,
                minVersion: 0,
                maxVersion: 0,
            };
            if (_data) {
                if (_data.children !== undefined) {
                    this.addChannelForm = {
                        channelId: _data.id,
                        name: _data.name
                    }
                } else {
                    this.addChannelForm = {
                        channelId: _data.channelId,
                        subChannelId: _data.id,
                        gameId: _data.gameId,
                        appId: _data.appId,
                        money: _data.money,
                        subName: _data.name,
                        subChannel: _data.subChannel,
                        adPlate: _data.adPlate,
                        adPlateNew: _data.adPlateNew,
                        minVersion: _data.minVersion,
                        maxVersion: _data.maxVersion,
                        state: _data.state,
                    }
                }
                this.radio = _data.children !== undefined ? '0' : '1'
            }
            this.addChannelDialogVisible = true
        },

        confirmAddChannelDialog() {
            let _message = '';
            if (this.radio === '1' && this.addChannelForm.gameId === '') {
                _message = '请选择首开展示'
            }
            if (this.radio === '0' && this.addChannelForm.name === '') {
                _message = '请填写渠道组名称'
            }
            if (this.radio === '1' && this.addChannelForm.subChannel === '') {
                _message = '请填写子渠道号'
            }
            if (this.radio === '1' && this.addChannelForm.subName === '') {
                _message = '请填写子渠道名称'
            }
            if (this.radio === '1' && this.addChannelForm.channelId === '') {
                _message = '请选择渠道组'
            }
            if (this.radio === '1' && this.addChannelForm.adPlate === '') {
                _message = '请选择老广告聚合平台'
            }
            if (this.radio === '1' && this.addChannelForm.adPlateNew === '') {
                _message = '请选择广新告聚合平台'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            let func = channelEdit;
            if (this.dialogType === 0) {
                if (this.radio === '0') {
                    func({
                        name: this.addChannelForm.name,
                    }).then(resp => {
                        this.search();
                        if (resp.data.status === 0) {
                            this.closeAddChannelDialog()
                        }
                    }).catch(function () {
                    })
                } else {
                    func({
                        channelId: this.addChannelForm.channelId,
                        subName: this.addChannelForm.subName,
                        subChannel: this.addChannelForm.subChannel,
                        appId: this.addChannelForm.appId,
                        gameId: this.addChannelForm.gameId,
                        adPlate: this.addChannelForm.adPlate,
                        adPlateNew: this.addChannelForm.adPlateNew,
                        minVersion: this.addChannelForm.minVersion,
                        maxVersion: this.addChannelForm.maxVersion,
                        money: this.addChannelForm.money,
                        state: this.addChannelForm.state,
                    }).then(resp => {
                        this.search();
                        if (resp.data.status === 0) {
                            this.closeAddChannelDialog()
                        }
                    }).catch(function () {
                    })
                }
            }

            if (this.dialogType === 1) {
                if (this.radio === '0') {
                    func({
                        channelId: this.addChannelForm.channelId,
                        name: this.addChannelForm.name,
                    }).then(resp => {
                        this.search();
                        if (resp.data.status === 0) {
                            this.closeAddChannelDialog()
                        }
                    }).catch(function () {
                    })
                } else {
                    func({
                        channelId: this.addChannelForm.channelId,
                        subChannelId: this.addChannelForm.subChannelId,
                        subName: this.addChannelForm.subName,
                        subChannel: this.addChannelForm.subChannel,
                        gameId: this.addChannelForm.gameId,
                        appId: this.addChannelForm.appId,
                        adPlate: this.addChannelForm.adPlate,
                        adPlateNew: this.addChannelForm.adPlateNew,
                        money: this.addChannelForm.money,
                        minVersion: this.addChannelForm.minVersion,
                        maxVersion: this.addChannelForm.maxVersion,
                        state: this.addChannelForm.state,
                    }).then(resp => {
                        this.search();
                        if (resp.data.status === 0) {
                            this.closeAddChannelDialog()
                        }
                    }).catch(function () {
                    })
                }
            }
        },
        closeAddChannelDialog() {
            this.addChannelDialogVisible = false;
            this.radio = '0';
        },
        update(row) {
            updateState(row.state, row.id).then(resp => {
                if (resp.data.msg === '成功') {
                    console.log('ok');
                }
            });
        },
        openDesc() {
            this.channelList.forEach(function (channel) {
                channel.children.sort((a, b) => (b.state - a.state));
            });
            this.isFold = false;
        },
        openAsc() {
            this.channelList.forEach(function (channel) {
                channel.children.sort((a, b) => (a.state - b.state));
            });
            this.isFold = false;
        },
        selectList() {
            appAll().then(resp => {
                this.appList = resp.data.info;
            });
            adPlateEnum().then(resp => {
                this.adPlateEnum = resp.data.info;
            });
            gameSimpleList().then(resp => {
                this.gameList = resp.data.info;
                this.gameList.unshift({id: -1, name: '游戏中心'})
            });
        },
        search() {
            channelList().then(resp => {
                this.channelList = resp.data.info;
            });
        }
    },
    created() {
        this.search();
    }
}
</script>

<style lang="less" scoped>
.treeTable {
    margin-top: 15px;
}
</style>
